import script from "./LotteryDraw.vue?vue&type=script&setup=true&lang=js"
export * from "./LotteryDraw.vue?vue&type=script&setup=true&lang=js"

import "./LotteryDraw.vue?vue&type=style&index=0&id=6a84d982&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/192.255.151.37/new/tiempos-h55/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a84d982"]])

export default __exports__